
import React, { useRef, useState } from 'react'

import './InputSearch.scss'

interface Props {
  placeholder: string
  showIcon?: boolean
  onEnter?: () => void
  onChange?: (value: string) => void
}

const InputSearch = (props: Props) => {

  const { placeholder, onChange } = props

  const inputRef = useRef<HTMLInputElement>(null)

  const [ isFocused, setIsFocused ] = useState(false)

  return (
    <div className={`input-search ${isFocused ? 'focused' : ''}`}
      onClick={() => {

        if (inputRef.current) {
          inputRef.current.focus()
        }
      }}
    >
      <div className="icon-container">
        <span className="icon-buscar"></span>
      </div>
      <input
        ref={inputRef}
        className='input-control'
        type="text"
        placeholder={placeholder}
        onChange={(e: any) => {

          if (onChange) {
            onChange(e.target.value)
          }
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </div>
  )
}

export default InputSearch
